export default "__VITE_ASSET__72200cfe__"